import React from 'react';
import { FileText, GitBranch, Lock, Mic, PenLine } from 'lucide-react';
import { cn } from '@/lib/utils';
import morrisonCover from '../../../assets/landing/morrison-archive-cover.jpg';
import { SAMPLE_ARCHIVE } from '../../../content/howItWorksDemoContent';
import { IllustrativeLabel } from './DemoChrome';

const CAPTION = 'Illustrative preview. Your archive grows with the people and memories you add.';

export function IllustratedArchivePreview({
  variant = 'featured',
  className,
  showCaption = false,
  showLabel = true,
}) {
  const isFeatured = variant === 'featured';

  return (
    <div
      className={cn(
        'illustrated-archive-preview',
        isFeatured ? 'illustrated-archive-preview--featured' : 'illustrated-archive-preview--compact',
        className,
      )}
    >
      {showLabel ? <IllustrativeLabel className="illustrated-archive-preview__label" /> : null}

      <div className="illustrated-archive-preview__card">
        <div className="illustrated-archive-preview__cover">
          <img src={morrisonCover} alt="" loading="lazy" />
          <div className="product-demo-archive__cover-overlay" />
          <div className="illustrated-archive-preview__cover-overlay">
            <div>
              <p className="illustrated-archive-preview__archive-name">{SAMPLE_ARCHIVE.name}</p>
              <p className="illustrated-archive-preview__archive-type">Family archive</p>
            </div>
            <span className="product-demo-panel__badge">
              <Lock className="mr-1 inline h-3 w-3" aria-hidden />
              Private
            </span>
          </div>
        </div>

        <div className="illustrated-archive-preview__body">
          <div className="illustrated-archive-preview__person">
            <p className="illustrated-archive-preview__person-name">{SAMPLE_ARCHIVE.person}</p>
            <p className="illustrated-archive-preview__person-meta">{SAMPLE_ARCHIVE.personMeta}</p>
          </div>

          {isFeatured ? (
            <div className="illustrated-archive-preview__grid">
              <article className="illustrated-archive-preview__tile">
                <Mic className="illustrated-archive-preview__tile-icon" strokeWidth={1.75} aria-hidden />
                <p className="illustrated-archive-preview__tile-label">Voice memory</p>
                <p className="illustrated-archive-preview__tile-copy">Kitchen stories</p>
                <p className="illustrated-archive-preview__tile-meta">3:42 · Transcript ready</p>
              </article>
              <article className="illustrated-archive-preview__tile">
                <FileText className="illustrated-archive-preview__tile-icon" strokeWidth={1.75} aria-hidden />
                <p className="illustrated-archive-preview__tile-label">Document</p>
                <p className="illustrated-archive-preview__tile-copy">Marriage certificate</p>
                <p className="illustrated-archive-preview__tile-meta">1962 · Linked to Eleanor</p>
              </article>
              <article className="illustrated-archive-preview__tile">
                <GitBranch className="illustrated-archive-preview__tile-icon" strokeWidth={1.75} aria-hidden />
                <p className="illustrated-archive-preview__tile-label">Family tree</p>
                <p className="illustrated-archive-preview__tile-copy">Three generations linked</p>
                <p className="illustrated-archive-preview__tile-meta">People and relationships</p>
              </article>
              <article className="illustrated-archive-preview__tile illustrated-archive-preview__tile--connections">
                <GitBranch className="illustrated-archive-preview__tile-icon" strokeWidth={1.75} aria-hidden />
                <p className="illustrated-archive-preview__tile-label">Family connections</p>
                <ul className="illustrated-archive-preview__connections">
                  {SAMPLE_ARCHIVE.connections.map((line) => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>
              </article>
            </div>
          ) : (
            <div className="illustrated-archive-preview__chips">
              <span className="product-demo-chip">
                <PenLine className="h-3.5 w-3.5 text-[#c9a961]" aria-hidden />
                Stories
              </span>
              <span className="product-demo-chip">
                <Mic className="h-3.5 w-3.5 text-[#c9a961]" aria-hidden />
                Voice notes
              </span>
              <span className="product-demo-chip">
                <FileText className="h-3.5 w-3.5 text-[#c9a961]" aria-hidden />
                Documents
              </span>
            </div>
          )}
        </div>
      </div>

      {showCaption ? (
        <p className="illustrated-archive-preview__caption">{CAPTION}</p>
      ) : null}
    </div>
  );
}

export default IllustratedArchivePreview;
